import videojs from 'video.js';

import { Event } from '@src/types/event';

const MuteToggle = videojs.getComponent('MuteToggle');

class CustomMuteToggle extends MuteToggle {
  public getIsMuted() {
    return this.player_.muted() || this.player().volume() === 0;
  }

  public handleClick(evt: videojs.EventTarget.Event) {
    this.player().trigger(this.getIsMuted() ? Event.UNMUTE : Event.MUTE);
    super.handleClick(evt);
  }
}

// override video.js original MuteToggle
videojs.registerComponent('MuteToggle', CustomMuteToggle);

export default CustomMuteToggle;
